import type { UserRole } from '../../api/generated/client';

const KEY_USER_ROLE = 'DIS_REACT_USER_ROLE';

export class LocalStore {
    retrieveUserRole = () => localStorage.getItem(KEY_USER_ROLE) as UserRole;
    storeUserRole = (role: UserRole) => localStorage.setItem(KEY_USER_ROLE, role);
}
